import { c as _c } from "react/compiler-runtime";
import { useWatch } from "react-hook-form";
import SpecificLocationMapCaller from "./SpecificLocationMapCaller";
import { useReversedGeolocationMutation } from "@/components/modules/portfolio/api/mutations/useReversedGeolocationMutation";
import { Loader2, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useModal } from "@/components/providers/modal-provider/ModalProvider";
export function SpecificLocationModalContent(t0) {
  const $ = _c(29);
  const {
    form
  } = t0;
  const {
    closeModal
  } = useModal();
  const {
    mutate: fetchReversedGeolocation,
    isPending: isReversedGeolocationPending
  } = useReversedGeolocationMutation();
  let t1;
  if ($[0] !== form.control) {
    t1 = {
      control: form.control,
      name: "latitude"
    };
    $[0] = form.control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const latitude = useWatch(t1);
  let t2;
  if ($[2] !== form.control) {
    t2 = {
      control: form.control,
      name: "longitude"
    };
    $[2] = form.control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const longitude = useWatch(t2);
  let t3;
  if ($[4] !== form.control) {
    t3 = {
      control: form.control,
      name: "locationNormalizedName"
    };
    $[4] = form.control;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const normalizedName = useWatch(t3);
  let t4;
  if ($[6] !== fetchReversedGeolocation || $[7] !== form) {
    t4 = (lat, lng) => {
      form.setValue("latitude", lat.toString());
      form.setValue("longitude", lng.toString());
      fetchReversedGeolocation({
        lat,
        lon: lng
      }, {
        onSuccess: data => {
          form.setValue("locationNormalizedName", data.data.display_name);
          form.setValue("parishName", data.data.address.village || data.data.address.suburb);
          form.setValue("municipalityName", data.data.address.county);
          form.setValue("districtName", data.data.address.city);
        }
      });
    };
    $[6] = fetchReversedGeolocation;
    $[7] = form;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onLocationChange = t4;
  let t5;
  if ($[9] !== isReversedGeolocationPending) {
    t5 = isReversedGeolocationPending && <div className="absolute w-full h-full flex justify-start items-start p-6 bg-black/20 z-[100000]"><Loader2 className="animate-spin text-primary w-10 h-10" /></div>;
    $[9] = isReversedGeolocationPending;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== latitude || $[12] !== longitude || $[13] !== onLocationChange) {
    t6 = <SpecificLocationMapCaller latitude={latitude} longitude={longitude} onMarkerChange={onLocationChange} data-sentry-element="SpecificLocationMapCaller" data-sentry-source-file="SpecificLocationModalContent.tsx" />;
    $[11] = latitude;
    $[12] = longitude;
    $[13] = onLocationChange;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="relative w-full h-[60dvh] sm:h-180 rounded-xl overflow-hidden">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="font-semibold text-foreground">Local: </span>;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== normalizedName) {
    t9 = <p className="text-muted-foreground mt-4 text-sm break-words line-clamp-2">{t8}{normalizedName}</p>;
    $[19] = normalizedName;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = !latitude || !longitude;
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MapPin className="h-4 w-4 mr-2" data-sentry-element="MapPin" data-sentry-source-file="SpecificLocationModalContent.tsx" />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== closeModal || $[23] !== t10) {
    t12 = <Button variant="simpleDark" className="w-full mt-4" onClick={closeModal} disabled={t10} data-sentry-element="Button" data-sentry-source-file="SpecificLocationModalContent.tsx">{t11}Confirm Location</Button>;
    $[22] = closeModal;
    $[23] = t10;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t7 || $[27] !== t9) {
    t13 = <div className="w-full sm:w-180 h-full" data-sentry-component="SpecificLocationModalContent" data-sentry-source-file="SpecificLocationModalContent.tsx">{t7}{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t7;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}